import { render, staticRenderFns } from "./box.vue?vue&type=template&id=7fa993cc&scoped=true"
import script from "./box.vue?vue&type=script&lang=ts"
export * from "./box.vue?vue&type=script&lang=ts"
import style0 from "./box.vue?vue&type=style&index=0&id=7fa993cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa993cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa993cc')) {
      api.createRecord('7fa993cc', component.options)
    } else {
      api.reload('7fa993cc', component.options)
    }
    module.hot.accept("./box.vue?vue&type=template&id=7fa993cc&scoped=true", function () {
      api.rerender('7fa993cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/stockout/box.vue"
export default component.exports